export const GlobalCookieVariables = {
    SHOOLUK_VISIT: 'shooluk-visit',
    SHOOLUK_CLICK: 'shooluk-click',
    SHOOLUK_NOTICE_CLOSE: 'shooluk-notice-close'
}